import { ConsentType } from "../ConsentAudit";

export interface ProductAttributes {
  code: string;
  name: string;
  description: string;
  value: number;
}

export interface ProductVersion {
  startDate: string;
  endDate: string;
  productVersion: number;
  productAttributes: ProductAttributes[];
}

export interface ProductDetails {
  code: string;
  name: string;
  description: string;
  productType: string;
  productGroup: string;
  productVersions: ProductVersion[];
}

export interface ProductList {
  data: ProductDetails[];
  count: number;
  total: number;
  status: number;
}

export interface ProductDataForSwift {
  name: string;
  mph: string;
  interest: string;
  percentage: string;
  maturity_days?: number
}

export enum TypeForNCash {
  MAX_LIMIT = 'Max nCash',
  INTEREST_ONLY = 'Interest Only'
}

export interface ProductDataForNCash {
  type: TypeForNCash;
  frequency: string;
  date: string;
}

export interface ProductDetailsForExpansionTab {
  name: string;
  value: number | string;
}

export interface ProductListForCreatePortfolio {
  consents: Consent[];
  productName: string;
  investmentAmount: number;
  productCode?: string;
  productVersion?: string;
}

export interface Consent {
  consentType: ConsentType;
  value: boolean;
}

export interface MasterProduct {
  count: number;
  data: MasterProductData[];
  total: number;
}

export interface MasterProductData {
  code: string;
  name: string;
  productGroup: string;
  productType: string;
}

export interface RiskScore {
  [key: string]: {
    [key: string]: number;
  };
}

export enum ProductCode {
  NAME = 'NAME',
  MAX_FCASH_AMOUNT_PER_MONTH = 'MAX_FCASH_AMOUNT_PER_MONTH',
  MAX_PORTFOLIO_AMOUNT = 'MAX_PORTFOLIO_AMOUNT',
  MATURITY_DAYS = 'MATURITY_DAYS',
  MAX_LOAN_ALLOCATION_ROI = 'MAX_LOAN_ALLOCATION_ROI',
  MIN_REINVESTED_PORTFOLIO_AMOUNT = 'MIN_REINVESTED_PORTFOLIO_AMOUNT',
  MIN_CUMULATIVE_REINVESTED_PORTFOLIO_AMOUNT = 'MIN_CUMULATIVE_REINVESTED_PORTFOLIO_AMOUNT',
  MIN_LOAN_ALLOCATION_ROI = 'MIN_LOAN_ALLOCATION_ROI',
  MATURITY_NCASH = 'MATURITY_NCASH',
  MAX_LOAN_ALLOCATION_AMOUNT = 'MAX_LOAN_ALLOCATION_AMOUNT',
  MIN_CUMULATIVE_AUTO_PORTFOLIO_AMOUNT = 'MIN_CUMULATIVE_AUTO_PORTFOLIO_AMOUNT',
  ROI = 'ROI',
  MHP = 'MHP',
  MIN_SWIFT_PORTFOLIO_AMOUNT = 'MIN_SWIFT_PORTFOLIO_AMOUNT',
  MIN_CUMULATIVE_SWIFT_PORTFOLIO_AMOUNT = 'MIN_CUMULATIVE_SWIFT_PORTFOLIO_AMOUNT',
  MIN_AUTO_PORTFOLIO_AMOUNT = 'MIN_AUTO_PORTFOLIO_AMOUNT',
  MIN_LOAN_ALLOCATION_AMOUNT = 'MIN_LOAN_ALLOCATION_AMOUNT',
  MHP_FRONTEND_DISPLAY = "MHP_FRONTEND_DISPLAY",
}